module.exports = __webpack_public_path__ + "static/media/facebook.06445f22.svg";